<section class="ai" #aiRoot>
  <!-- ---------- background (static during accordion transitions) ---------- -->
  <div class="ai__bg" aria-hidden="true">
    <span class="ai__glow ai__glow--pink"></span>
    <span class="ai__glow ai__glow--violet"></span>
    <span class="ai__glow ai__glow--blue"></span>

    <svg class="ai__net" viewBox="0 0 640 420" fill="none" preserveAspectRatio="xMidYMid slice">
      <g class="ai__net-lines">
        <path d="M40 60 L150 30 L268 92 L360 40 L470 96 L560 52 L628 110" />
        <path d="M150 30 L196 140 L268 92 L330 178 L360 40" />
        <path d="M196 140 L104 196 L40 60" />
        <path d="M330 178 L470 96 L556 190 L628 110" />
        <path d="M104 196 L228 264 L330 178" />
        <path d="M228 264 L360 330 L468 268 L556 190" />
        <path d="M360 330 L300 400" />
        <path d="M468 268 L590 320" />
      </g>
      <g class="ai__net-dots">
        <circle cx="40" cy="60" r="3" /><circle cx="150" cy="30" r="3.5" />
        <circle cx="268" cy="92" r="3" /><circle cx="360" cy="40" r="3.5" />
        <circle cx="470" cy="96" r="3" /><circle cx="560" cy="52" r="3" />
        <circle cx="628" cy="110" r="3" /><circle cx="196" cy="140" r="3" />
        <circle cx="104" cy="196" r="3.5" /><circle cx="330" cy="178" r="3" />
        <circle cx="556" cy="190" r="3" /><circle cx="228" cy="264" r="3" />
        <circle cx="360" cy="330" r="3.5" /><circle cx="468" cy="268" r="3" />
        <circle cx="300" cy="400" r="2.5" /><circle cx="590" cy="320" r="2.5" />
      </g>
    </svg>

    <span class="ai__particles">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </span>
  </div>

  <!-- ---------- content ---------- -->
  <div class="container ai__inner">
    <header class="ai__head" [@reveal]="revealState()" [@.disabled]="reduced">
      <div class="ai__head-left">
        <span class="ai__eyebrow">AI-Powered Mobile App Development</span>
        <h2 class="ai__title">
          Service that Solves Real<br />
          Business Challenges
        </h2>
      </div>
      <p class="ai__lede">
        Our mobile app development company leverages advanced technology, tapping
        into the potential of AI to redefine user journey and empower your
        business.
      </p>
    </header>

    <div
      class="ai__grid"
      role="tablist"
      aria-label="AI solutions"
      [@gridReveal]="revealState()"
      [@.disabled]="reduced"
    >
      <app-ai-feature-card
        *ngFor="let f of features; trackBy: trackById"
        [feature]="f"
        [expanded]="selectedCard() === f.id"
        (activate)="select(f.id)"
      ></app-ai-feature-card>
    </div>
  </div>
</section>
